import type { AssessmentMode } from '../types/assessment-mode.types';

export const MODES_REQUIRING_CONNECTION: AssessmentMode[] = ['text'];

export function modeRequiresConnection(mode: AssessmentMode, deviceMrx: boolean): boolean {
  return MODES_REQUIRING_CONNECTION.includes(mode) || (mode === 'guided' && !deviceMrx);
}
